// causesSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk to fetch causes
export const fetchCauses = createAsyncThunk("causes/fetchCauses", async () => {
  const response = await axios.get(`${import.meta.env.VITE_API_URL}/causes`);
  // console.log("The cause response is =>", response);
  return response.data.causes; // Assuming `causes` is the array in the response
});

const causesSlice = createSlice({
  name: "causes",
  initialState: {
    causes: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCauses.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCauses.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.causes = action.payload;
      })
      .addCase(fetchCauses.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

const causeReducer = causesSlice.reducer;

export default causeReducer;
